import { FEATURE_MODULES } from '@/constants/feature-modules';

/**
 * Maps {@link FEATURE_MODULES} values to `companyPreferences.activeModules` keys (API naming).
 * @type {Record<string, string>}
 */
const MODULE_KEY_TO_PREFERENCE_KEY = {
  [FEATURE_MODULES.Recruitment]: 'Recruitment',
  [FEATURE_MODULES.Onboarding]: 'Onboarding',
  [FEATURE_MODULES.Pulse]: 'Pulse',
  [FEATURE_MODULES.TimeOff]: 'Time-off',
  [FEATURE_MODULES.Profile]: 'Profile',
  [FEATURE_MODULES.Home]: 'Home',
  [FEATURE_MODULES.OneOnOne]: '1on1',
  [FEATURE_MODULES.PerformanceReview]: 'Performance-Review',
  [FEATURE_MODULES.Inbox]: 'Inbox',
  [FEATURE_MODULES.Calibration]: 'Calibration',
  [FEATURE_MODULES.Compliance]: 'Compliance',
  [FEATURE_MODULES.CustomerSatisfaction]: 'CustomerSatisfaction',
  [FEATURE_MODULES.Organigram]: 'Organigram',
  [FEATURE_MODULES.Recognition]: 'Recognition',
  [FEATURE_MODULES.News]: 'News',
  [FEATURE_MODULES.Development]: 'Development',
  [FEATURE_MODULES.Career]: 'Career',
  [FEATURE_MODULES.Goals]: 'Goals',
  [FEATURE_MODULES.Admin]: 'Admin',
  [FEATURE_MODULES.PunchInOut]: 'PunchInOut',
  [FEATURE_MODULES.Rewards]: 'Rewards',
};

/**
 * Whether a feature module is enabled for the company (same rules as {@link useIsFeatureModuleEnable}).
 * Safe to use inside `DataProvider` where the hook cannot run.
 *
 * @param {import('@/common/dataContext').CompanyPreferences | null | undefined} companyPreferences
 * @param {import('@/constants/types').FeatureModule | string} moduleKey
 * @returns {boolean}
 */
export function isFeatureModuleEnabled(companyPreferences, moduleKey) {
  if (!companyPreferences?.activeModules) return false;

  const apiKey = MODULE_KEY_TO_PREFERENCE_KEY[moduleKey] || moduleKey;
  return Boolean(companyPreferences.activeModules[apiKey]);
}
